//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Modal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOpen () {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    $route () {
      // eslint-disable-next-line vue/no-mutating-props
      this.isOpen = false
      document.body.style.overflow = 'auto'
      this.close()
    }
  },
  mounted () {
    const vm = this
    window.addEventListener('keyup', (ev) => {
      if (ev.key === 'Escape') {
        vm.close()
      }
    })
    this.checkAndclose()
  },
  updated () {
    this.checkAndclose()
  },
  beforeDestroy () {
    document.body.style.overflow = 'auto'
  },
  methods: {
    checkAndclose () {
      const modal = document.getElementById('myModal')
      window.onclick = (e) => {
        if (e.target === modal) {
          this.close()
        }
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
